import React from "react";
import { TipsForWeek } from "@aph/ui-lib-humanx";
import { TipItem, TopTips } from "@/components/PagePiller/api/interface";
import { DeviceInfo } from "@/interface/deviceInfo";
import Slider, { Slide } from "@/components/Slider";
import IconRight from "$/icons/icon-right.svg";
import IconLeft from "$/icons/icon-left.svg";
import { RegisterRefType } from "@/components/PageHome/interfaces";
import SwipeSlider from "@/components/swipeSlider";
import styles from "./TopTips.module.scss";

interface TopTipsProps {
  data: TopTips;
  userAgent: DeviceInfo;
  registerRef?: RegisterRefType;
}

const TopTipsComponent: React.FC<TopTipsProps> = ({ data, userAgent, registerRef }) => {
  const { Title: title, Tips: tips } = data;
  const isMobile = userAgent?.isMobile;

  return (
    <section
      data-ref_id={data?.refId}
      ref={(el) => {
        if (data?.ShowHeadingInIndex && registerRef && data?.refId) registerRef(data?.refId, el);
      }}
      className={`${styles.container} scrollMargin spacingBetweenSections`}
    >
      <div className={"container"}>
        {title && <div className={styles.title} dangerouslySetInnerHTML={{ __html: title }} />}
        {isMobile ? (
          <>
            <SwipeSlider topTips={[...tips?.data]?.reverse()} />
          </>
        ) : (
          <div className={`${styles.sliderWrapper} ${isMobile ? styles.mobile : ""}`}>
            <Slider
              autoplay={false}
              dotsWrapperClass={styles.dotsWrapperClass}
              dotClassActive={styles.dotClassActive}
              dotClass={styles.dotClass}
              slidesToShow={isMobile ? 1 : 3}
              isCircular={isMobile}
              columnGap={20}
              showDots={!isMobile}
              showArrows={!isMobile}
              nextArrow={<IconRight className={`${styles.arrows} ${styles.arrowNext}`} />}
              prevArrow={<IconLeft className={`${styles.arrows} ${styles.arrowPrev}`} />}
              overflow={isMobile ? "visible" : "hidden"}
            >
              {tips?.data?.map((tip: TipItem, index) => {
                const { Title, Description, Image } = tip?.attributes;

                return (
                  <Slide index={index} key={index}>
                    <TipsForWeek
                      shadowColor={index % 2 === 0 ? "#EE691F" : "#CFD7FF"}
                      backgroundColor={index % 2 === 0 ? "#F15A24" : "#D7DFFF"}
                      title={Title}
                      description={Description}
                      sideImg={Image?.data?.attributes?.url}
                      fontColur={index % 2 === 0 ? "#ffffff" : "#222222"}
                    />
                  </Slide>
                );
              })}
            </Slider>
          </div>
        )}
      </div>
    </section>
  );
};

export default TopTipsComponent;
